// OrderConfirmation Component
import React from 'react';

export function OrderConfirmation({ order, venue, settings, onNewOrder }) {
  const formatTime = (datetime) => {
    if (!datetime) return 'ASAP';
    try {
      const date = new Date(datetime);
      return date.toLocaleString('en-US', {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
      });
    } catch {
      return datetime;
    }
  };

  return (
    <div className="confirmation">
      <div className="confirmation__icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
          <polyline points="22 4 12 14.01 9 11.01"/>
        </svg>
      </div>

      <h1 className="confirmation__title">Order Confirmed!</h1>
      <p className="confirmation__order-id">Order #{order.orderid}</p>

      <div className="confirmation__details">
        <div className="confirmation__detail">
          <span className="confirmation__detail-label">Order Type</span>
          <span className="confirmation__detail-value">
            {order.orderType?.name || 'Takeout'}
          </span>
        </div>

        <div className="confirmation__detail">
          <span className="confirmation__detail-label">Pickup Time</span>
          <span className="confirmation__detail-value">
            {formatTime(order.scheduledTime)}
          </span>
        </div>

        <div className="confirmation__detail">
          <span className="confirmation__detail-label">Total</span>
          <span className="confirmation__detail-value confirmation__detail-value--total">
            ${order.total.toFixed(2)}
          </span>
        </div>
      </div>

      <div className="confirmation__items">
        <h3 className="confirmation__items-title">Your Order</h3>
        {order.items.map((item, i) => (
          <div key={i} className="confirmation__item">
            <span className="confirmation__item-qty">{item.quantity}×</span>
            <span className="confirmation__item-name">{item.name}</span>
            <span className="confirmation__item-price">${item.lineTotal.toFixed(2)}</span>
          </div>
        ))}
      </div>

      <div className="confirmation__contact">
        <p>We'll text you when your order is ready!</p>
        {settings?.phone && (
          <p>
            Questions? Call us at{' '}
            <a href={`tel:${settings.phone}`}>{settings.phone}</a>
          </p>
        )}
      </div>

      <button className="confirmation__new-order" onClick={onNewOrder}>
        Start New Order
      </button>
    </div>
  );
}

// LoadingScreen Component
export function LoadingScreen({ theme }) {
  return (
    <div className={`loading-screen theme--${theme || 'classic'}`}>
      <div className="loading-screen__content">
        <div className="loading-screen__spinner">
          <svg viewBox="0 0 50 50">
            <circle cx="25" cy="25" r="20" fill="none" strokeWidth="4"/>
          </svg>
        </div>
        <p className="loading-screen__text">Loading menu...</p>
      </div>
    </div>
  );
}

// ErrorScreen Component
export function ErrorScreen({ message, onRetry }) {
  return (
    <div className="error-screen">
      <div className="error-screen__content">
        <div className="error-screen__icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="8" x2="12" y2="12"/>
            <line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
        </div>
        <h1 className="error-screen__title">Something went wrong</h1>
        <p className="error-screen__message">{message}</p>
        <button className="error-screen__retry" onClick={onRetry}>
          Try Again
        </button>
      </div>
    </div>
  );
}

export default { OrderConfirmation, LoadingScreen, ErrorScreen };
